const ENVIRONMENTS = {
  production: {
    BASE_URL: "https://test4.acrossassist.in",
    ATP_API_BASE_URL: "https://onboarding.acrossassist.in/",
  },
  staging: {
    BASE_URL: "https://test4.acrossassist.in",
    ATP_API_BASE_URL: "https://onboarding.acrossassist.in/",
  },
  development: {
    BASE_URL: "http://localhost:3000",
    ATP_API_BASE_URL: "https://onboarding.acrossassist.in/",
  },
};

const getEnvironment = () => {
  const baseUrl = window.location.origin;
  if (baseUrl === ENVIRONMENTS.production.BASE_URL) {
    return "production";
  } else if (baseUrl === ENVIRONMENTS.staging.BASE_URL) {
    return "staging";
  } else if (baseUrl === ENVIRONMENTS.development.BASE_URL) {
    return "development";
  } else {
    return "development";
  }
};

const CURRENT_ENV = getEnvironment();

export const URL_CONFIG = {
  ...ENVIRONMENTS[CURRENT_ENV],
};
